import React from "react";
import { useState } from "react";
import { useRef } from "react";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useEffect } from "react";
import { useParams } from "react-router-dom";

const initialFaqInfo = {
  question: "",
  answer: ""
};

const FAQForm = (props) => {
  const { title } = props;

  const [faqInfo, setFaqInfo] = useState(initialFaqInfo);
  const question = useRef("");
  const [answer, setAnswer] = useState('');
  const { oldId } = useParams();

  const formSubmitHandler = async (e) => {
    e.preventDefault();
    if (question.current.value.length > 0 && answer.length > 0) {
      const obj = {
        question: question.current.value,
        answer: answer,
        oldId: oldId
      }
      const response = await fetch(`${process.env.REACT_APP_API_URL}add-update-faq`, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const resData = await response.json();
      if (resData.status === true) {
        // success message
      } else {
        // error message 
      }
    } else {
      console.log('Validations Called')
    }
  };

  useEffect(() => {
    try {
      if (oldId) {
        (async() => {
          const response = await fetch(`${process.env.REACT_APP_API_URL}get-faq-details/` + oldId);
          const resData = await response.json();
          setFaqInfo(resData.faq)
        })();
      }
    } catch (error) {
      console.log(error);
    }
  },[])

  return (
    <React.Fragment>
      <div className="content-body">
        <div className="container-fluid">
          <div className="d-flex align-items-center mb-4">
            <h4 className="fs-20 font-w600 mb-0 me-auto">{title}</h4>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <form onSubmit={formSubmitHandler}>
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-12 col-md-12 mb-4">
                        <label className="form-label font-w600">
                          Question<span className="text-danger scale5 ms-2">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control solid"
                          placeholder="Question"
                          aria-label="Question"
                          name="Question"
                          ref={question}
                          defaultValue={faqInfo.question}
                        />
                      </div>
                      <div className="col-xl-12 col-md-12 mb-4">
                        <label className="form-label font-w600">
                          Answer<span className="text-danger scale5 ms-2">*</span>
                        </label>
                        <CKEditor
                            editor={ ClassicEditor }
                            data={faqInfo.answer}
                            onChange={ ( event, editor ) => {
                                const data = editor.getData();
                                setAnswer(data);
                            } }
                        />
                      </div>
                      <div className="col-xl-12 col-md-12 mb-4 d-flex justify-content-end">
                        <button className="btn btn-primary" type="submit">Submit</button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FAQForm;
